var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPenToSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1255",
    "data-name": "Group 1255",
    transform: "translate(-217 -77)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M14.222,7.538v6.684H1.778V1.778H8.462V0H1.778A1.777,1.777,0,0,0,0,1.778V14.222A1.772,1.772,0,0,0,1.778,16H14.222A1.777,1.777,0,0,0,16,14.222V7.538Z",
    transform: "translate(217 77)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M16.489,2.4a.59.59,0,0,0,0-.835h0L15.1.178a.589.589,0,0,0-.834,0h0L13.175,1.263,15.4,3.485m-9.4,4.966v2.222H8.215l6.556-6.56L12.549,1.891Z",
    transform: "translate(216.334 76.999)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenToSquare);
export default __webpack_public_path__ + "static/media/pen_to_square.358fa6b4e0404c93678634c4c947703b.svg";
export { ForwardRef as ReactComponent };